export default __webpack_public_path__ + "static/media/WhatsApp Community_RAKGulf.60405ce2.png";